import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { withChatwoot } from '@/lib/chatwoot'

const DASHBOARD_PREFIXES = ['/cont', '/firma', '/worker', '/admin'] as const

function isDashboardPath(pathname: string): boolean {
  return DASHBOARD_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/'),
  )
}

// Show the Chatwoot bubble only on the role dashboards (/cont, /firma,
// /worker, /admin); hide it on the landing page, booking flow, and auth
// pages so support chat doesn't compete with conversion-critical surfaces.
//
// withChatwoot() waits for the widget to actually be mounted before calling
// into the SDK — see lib/chatwoot.ts for why that matters.
export default function ChatwootRouteGate() {
  const { pathname } = useLocation()

  useEffect(
    () =>
      withChatwoot((cw) => {
        cw.toggleBubbleVisibility(isDashboardPath(pathname) ? 'show' : 'hide')
      }),
    [pathname],
  )

  return null
}
